/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Manual_Removal_TitleInputs */

const en_delete_account_manual_removal_title = /** @type {(inputs: Delete_Account_Manual_Removal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Further action needed`)
};

const es_delete_account_manual_removal_title = /** @type {(inputs: Delete_Account_Manual_Removal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere una acción adicional`)
};

const ar_delete_account_manual_removal_title = /** @type {(inputs: Delete_Account_Manual_Removal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يلزم اتخاذ إجراء إضافي`)
};

/**
* | output |
* | --- |
* | "Further action needed" |
*
* @param {Delete_Account_Manual_Removal_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_manual_removal_title = /** @type {((inputs?: Delete_Account_Manual_Removal_TitleInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Manual_Removal_TitleInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_manual_removal_title(inputs)
	if (locale === "es") return es_delete_account_manual_removal_title(inputs)
	return ar_delete_account_manual_removal_title(inputs)
});